<template>
  <div>
    <header-info
      :document-model="documentModel"
      class="pb-4 mb-4"
      @updated="fetchDocument"
    ></header-info>
    <translation-list
      :document-model="documentModel"
      @updated="fetchDocument"
    ></translation-list>
  </div>
</template>

<script>
import axios from 'axios';
import headerInfo from '../components/headerInfo';
import translationList from '../components/translationList';
import { mapMutations } from 'vuex';

export default {
  components: {
    headerInfo,
    translationList
  },
  props: {
    id: {
      type: [Number, String],
      default: 0
    }
  },
  data() {
    return {
      load: false,
      documentModel: {
        title: '',
        mci: '',
        pdf: null,
        productArea: 0,
        brand: [],
        language: '',
        type: 0
      }
    };
  },
  created() {
    this.fetchDocument();
  },
  methods: {
    ...mapMutations('snackbar', ['showSnackbar']),
    fetchDocument() {
      axios
        .get('/Document/' + this.id)
        .then(response => {
          this.documentModel = response.data;
          this.documentModel.brand = this.documentModel.brand.map(b => {
            return b.brand;
          });
        })
        .catch(error => {
          this.showSnackbar({ text: error, color: 'error' });
        });
    }
  }
};
</script>

<style></style>
